import moment from 'moment';
import "moment-timezone";
import React, { Component } from "react";
import { Nav, NavItem } from 'react-bootstrap';
import { Route, Switch } from 'react-router';
import { Link } from "react-router-dom";
import LoadingInProgress from "../Shared/LoadingInProgress";
import JSONDebugger from '../utils/JSONDebugger';
import ReferenceService from '../utils/ReferenceService';
import SeminarRegistrationsService from '../utils/SeminarRegistrationsService';
import SeminarsService from '../utils/SeminarsService';
import { timezones } from "../utils/variables";
import RegistrationsListView from './RegistrationsListView';




class Show extends Component {
  constructor(props) {
    super(props);

    const { view } = props.match.params
    this.state = { activeView: view, stats: {} }

  }

  componentDidMount() {
    const {
      match: { params }
    } = this.props;
    this.setState({ finishedLoading: false });
    SeminarsService.get(params.id).then(data => {
      this.setState({ finishedLoading: true, item: data });
    });

    ReferenceService.get('sms_group_messages').then(data => {
      this.setState({ smsGroupMessages: data })
    });
    ReferenceService.get('email_group_messages').then(data => {
      this.setState({ emailGroupMessages: data })
    });

    ReferenceService.get('leadmachine').then(data => {
      this.setState({ leadmachineConfig: data })
    });

    this.fetchStats()
  }


  fetchStats() {
    SeminarRegistrationsService.stats(this.props.match.params.id).then(data => {
      this.setState({ stats: data });
    });
  }

  handleSelect = (eventKey) => {
    this.setState({ activeView: eventKey }, () => {
    });
  }

  handleUpdatedDeals = () => { this.fetchStats() }

  render() {
    const { finishedLoading, stats } = this.state;
    const seminarID = this.props.match.params.id

    return (
      <div>
        {finishedLoading && this.state.item ? (
          <div>
            <h1 className="first-title" style={{ marginBottom: '20px' }}>
              <small className='pull-right'><Link to="/m1/seminars">back to Seminars</Link></small>
              {this.state.item.region}: {this.state.item.location} -
              {moment(this.state.item.at).tz(timezones[this.state.item.region]).format("MMM Do YYYY h:mm a")}
              <small> <Link to={`/m1/seminars/${this.props.match.params.id}/edit`}>edit seminar</Link></small>
            </h1>
            <div className='row'>
              <div className='col-md-12'>
                <Nav bsStyle="tabs" activeKey={this.state.activeView} onSelect={this.handleSelect.bind(this)}>
                  <NavItem eventKey='all' componentClass={Link} to={`/m1/seminars/${seminarID}/registrations/all`} href={`/m1/seminars/${seminarID}/registrations/all`}>All <span>({stats.all || 0})</span></NavItem>
                  <NavItem eventKey='confirmation' componentClass={Link} to={`/m1/seminars/${seminarID}/registrations/confirmation`} href={`/m1/seminars/${seminarID}/registrations/confirmation`}>Awaiting Confirmation <span>({stats.confirmation || 0})</span></NavItem>
                  <NavItem eventKey='attendance' componentClass={Link} to={`/m1/seminars/${seminarID}/registrations/attendance`} href={`/m1/seminars/${seminarID}/registrations/attendance`}>Awaiting Attendance <span>({stats.attendance || 0})</span></NavItem>
                  <NavItem eventKey='attended_no_tcs' componentClass={Link} to={`/m1/seminars/${seminarID}/registrations/attended_no_tcs`} href={`/m1/seminars/${seminarID}/registrations/attended_no_tcs`}>Attended - No TCS <span>({stats.attended_no_tcs || 0})</span></NavItem>
                  <NavItem eventKey='attended_tcs' componentClass={Link} to={`/m1/seminars/${seminarID}/registrations/attended_tcs`} href={`/m1/seminars/${seminarID}/registrations/attended_tcs`}>Attended- TCS Booked <span>({stats.attended_tcs || 0})</span></NavItem>
                  <NavItem eventKey='not_attended' componentClass={Link} to={`/m1/seminars/${seminarID}/registrations/not_attended`} href={`/m1/seminars/${seminarID}/registrations/not_attended`}>Did Not Attend <span>({stats.not_attended || 0})</span></NavItem>
                  <NavItem eventKey='cancelled' componentClass={Link} to={`/m1/seminars/${seminarID}/registrations/cancelled`} href={`/m1/seminars/${seminarID}/registrations/cancelled`}>Cancelled <span>({stats.cancelled || 0})</span></NavItem>
                </Nav>
                <div className="tab-content">
                  <Switch>
                    <Route path={'/m1/seminars/:id/registrations/:view'} render={(props) => <RegistrationsListView view={this.state.activeView} seminar={this.state.item} smsGroupMessages={this.state.smsGroupMessages} emailGroupMessages={this.state.emailGroupMessages} leadmachineConfig={this.state.leadmachineConfig} handleUpdatedDeals={this.handleUpdatedDeals} {...props} />} />
                  </Switch>
                </div>
              </div>
            </div>

            <div style={{ marginTop: '50px' }}><hr /><small className='pull-right'>Seminar #{seminarID}</small></div>

            <JSONDebugger json={this.state} />
          </div>
        ) : (
            <LoadingInProgress message="Loading" />
          )}
      </div>

    );
  }
}
export default Show;
